import React from 'react';
import { WithWistiaContext } from 'utils/WistiaContext';
import WistiaVideoModal from '../components/WistiaVideoModal';
import { CustomCtaPopoverContainer } from './styles';

const CustomVideoCta = ({ customCta, isModalOpen, isPlaying, setIsPlaying, toggleIsModalOpen }) => {
  const handleClick = () => {
    toggleIsModalOpen(!isModalOpen);
    setIsPlaying(!isPlaying);
  };

  return (
    <CustomCtaPopoverContainer className="wistia-video--wrapper">
      <div
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
          }
        }}
        onClick={() => handleClick()}
        style={{ cursor: 'pointer' }}
      >
        {customCta}
      </div>
      <WistiaVideoModal />
    </CustomCtaPopoverContainer>
  );
};

export default WithWistiaContext(CustomVideoCta);
